import {gql, useLazyQuery} from '@apollo/client'
import {useSelector} from 'react-redux'

export const GET_USER_PREFERENCE_PROSPECTS_COLUMN = gql`
  query GetUserPreferenceProspectsColumn($azureRole: String) {
    getUserPreferences(azureRole: $azureRole) {
      defaultColumns
    }
  }
`

export default function useUserPreferenceProspectsColumn() {
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const [conditionalHeaders, {data, loading, error, refetch}] = useLazyQuery(GET_USER_PREFERENCE_PROSPECTS_COLUMN, {
    variables: {
      ...(azureRole ? {azureRole} : {})
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  })
  return [conditionalHeaders, {data, loading, error, refetch}]
}
